import React from 'react';
import './ApproveRejectButtons.css';

const ApproveRejectButtons = ({
    enableApproveButtons,
    enableRejectButtons,
    handleApproveClick,
    handleRejectClick,
    areRequiredFieldsComplete
}) => {
    if (!enableApproveButtons && !enableRejectButtons) return null;

    return (
        <div className="approve-reject-buttons-container">
            {enableApproveButtons && (
            <button
                className="approve-reject-button pass-button"
                onClick={handleApproveClick}
                disabled={!areRequiredFieldsComplete()}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 12l2 2 4-4"></path>
                    <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                </svg>
                Aprobar
            </button>
            )}
            {enableRejectButtons && (
            <button
                className="approve-reject-button reject-button"
                onClick={handleRejectClick}
                disabled={!areRequiredFieldsComplete()}
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 6L6 18"></path>
                    <path d="M6 6l12 12"></path>
                </svg>
                Rechazar
            </button>
            )}
        </div>
    );
};

export default ApproveRejectButtons;